<template>
  <div>
    <van-nav-bar
      title="商品列表"
      left-text=""
      left-arrow
      @click-left="onClickLeft()"
    />
    <van-search
      v-model="searchValue"
      show-action
      placeholder="请输入商品关键词"
      @search="onSearch"
    />
    <van-grid :border="false" :column-num="2" :gutter="9">
      <van-grid-item v-for="(item, idx) in goodList" v-bind:key="idx">
        <goodGrid
          :goodName="item.GoodsName"
          :price="item.UnitPrice"
          :id="item.ID"
          :imgUrl="item.GoodsImg"
        ></goodGrid>
      </van-grid-item>
    </van-grid>
  </div>
</template>

<script>
import { Grid, GridItem, Search, NavBar } from "vant";
import goodGrid from "../components/goodGird";
import wx from "weixin-js-sdk";
export default {
  data() {
    return {
      searchValue: "",
      fileUrl: this.$file.url,
      goodList: [],
      categoryId: 0,
    };
  },
  methods: {
    onSearch() {
      var conditions = [];
      if (this.searchValue != "") {
        conditions.push({
          PropertyName: "GoodsName",
          Operater: 0,
          LogicOperater: 0,
          Value: this.searchValue,
        });
      }

      this.$http.SetConditions(conditions);
      this.GetData();
    },
    wxconfig: function () {
      var that = this;
      var url = encodeURIComponent(location.href.split("#")[0]);
      // url=encodeURIComponent("https://sale.reaca.net")
      this.$http.get("WeChatApi/GetJSConfig?url=" + url).then((response) => {
        console.log(response);
        wx.config({
          debug: false,
          appId: response.data.Data.appId,
          timestamp: parseInt(response.data.Data.timestamp),
          nonceStr: response.data.Data.noncestr,
          signature: response.data.Data.sign,
          jsApiList: [
            "updateAppMessageShareData",
            "updateTimelineShareData",
            "onMenuShareAppMessage",
          ],
        });

        wx.ready(function () {
          wx.updateAppMessageShareData({
            title: "天力管", // 分享标题
            desc: "天力管水电工程师活动中心", // 分享描述
            link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
            imgUrl: "https://oss.reaca.net/webPic/vr_logo.png", // require("../../assets/vr_logo.png"), // 分享图标
            success: function () {
              console.log("success");
              // 设置成功
            },
          });
          wx.updateTimelineShareData({
            title: "天力管", // 分享标题
            link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
            imgUrl: "https://oss.reaca.net/webPic/vr_logo.png", //require("../../assets/vr_logo.png"), // 分享图标
            success: function () {
              console.log("success");
            },
          });
          wx.onMenuShareAppMessage({
            title: "天力管", // 分享标题
            link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
            imgUrl: "https://oss.reaca.net/webPic/vr_logo.png", //require("../../assets/vr_logo.png"), // 分享图标
            success: function () {
              console.log("success");
            },
          });
        });
        // that.LoadImg(res);
      });
    },
    GetData() {
      var that = this;
      this.$http
        .get("Order/GetGoodsListByCategory", {
          params: {
            // categoryId: that.categoryId,
            pageIndex: 100,
          },
        })
        .then((res) => {
          var data = res.data.Data;
          for (let i = 0; i < data.length; i++) {
            if (data[i].GoodsImg != null) {
              if (data[i].GoodsImg.length > 0) {
                data[i].GoodsImg =
                  that.$file.url +
                  "Images/Mall/GoodsImg/" +
                  data[i].GoodsCode +
                  "/" +
                  data[i].GoodsImg;
                data[i].UnitPrice = toDecimal2(data[i].UnitPrice);
              }
            }
          }
          that.goodList = res.data.Data;
          that.$toast.clear();
        });
    },
    onClickLeft() {
      this.$router.back(-1);
    },
  },
  mounted() {
    // this.categoryId = this.$route.params.categoryId;
    this.wxconfig();
    this.GetData();
  },
  components: {
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Search.name]: Search,
    goodGrid,
    [NavBar.name]: NavBar,
  },
};

function toDecimal2(x) {
  var f = parseFloat(x);
  if (isNaN(f)) {
    return false;
  }
  var f = Math.round(x * 100) / 100;
  var s = f.toString();
  var rs = s.indexOf(".");
  if (rs < 0) {
    rs = s.length;
    s += ".";
  }
  while (s.length <= rs + 2) {
    s += "0";
  }
  return s;
}
</script>

<style>
</style>